import { useCallback } from 'react'
import smoothscroll from 'smoothscroll-polyfill'

import useEffectOnce from 'hooks/useEffectOnce'

const useWindowScroll = (): ((top: number, left: number) => void) => {
  useEffectOnce(() => {
    smoothscroll.polyfill()
  })

  return useCallback((top, left) => {
    if (!('scrollBehavior' in document.documentElement.style)) {
      window.scrollTo(top, left)
    }

    window.scrollTo({
      top,
      left,
      behavior: 'smooth',
    })
  }, [])
}

export default useWindowScroll
